import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { PublicLayout } from '@/layouts/PublicLayout';

const HomePage = lazy(() => import('@/pages/public/HomePage').then((m) => ({ default: m.HomePage })));
const SearchToursPage = lazy(() => import('@/pages/public/SearchPage').then((m) => ({ default: m.SearchToursPage })));
const ActivityPage = lazy(() =>
  import('@/pages/public/content/ActivityPage').then((m) => ({ default: m.ActivityPage }))
);
const CheckoutPage = lazy(() => import('@/pages/flows/CheckoutPage').then((m) => ({ default: m.CheckoutPage })));
const DestinationsPage = lazy(() =>
  import('@/pages/public/DestinationsPage').then((m) => ({ default: m.DestinationsPage }))
);
const SearchByCityPage = lazy(() =>
  import('@/pages/public/search/SearchByCityPage').then((m) => ({ default: m.SearchByCityPage }))
);
const SearchByCountryCategoryPage = lazy(() =>
  import('@/pages/public/search/SearchByCountryCategoryPage').then((m) => ({ default: m.SearchByCountryCategoryPage }))
);
const SearchByCategoryPage = lazy(() =>
  import('@/pages/public/search/SearchByCategoryPage').then((m) => ({ default: m.SearchByCategoryPage }))
);
const SearchByCityCategoryPage = lazy(() =>
  import('@/pages/public/search/SearchByCityCategoryPage').then((m) => ({ default: m.SearchByCityCategoryPage }))
);
const SearchByAttractionPage = lazy(() =>
  import('@/pages/public/search/SearchByAttractionPage').then((m) => ({ default: m.SearchByAttractionPage }))
);
const ExplorePage = lazy(() => import('@/pages/public/ExplorePage').then((m) => ({ default: m.ExplorePage })));
const SearchByCountryPage = lazy(() =>
  import('@/pages/public/search/SearchByCountryPage').then((m) => ({ default: m.SearchByCountryPage }))
);
const ProfilePage = lazy(() => import('@/pages/public/content/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const SuccessPage = lazy(() => import('@/pages/flows/SuccessPage').then((m) => ({ default: m.SuccessPage })));
const ReviewPage = lazy(() => import('@/pages/flows/ReviewPage').then((m) => ({ default: m.ReviewPage })));
const EmbeddedWidget = lazy(() => import('@/pages/widget/EmbeddedWidget').then((m) => ({ default: m.EmbeddedWidget })));
const TestEmbedPage = lazy(() => import('@/pages/widget/TestEmbedPage').then((m) => ({ default: m.TestEmbedPage })));
const NotFoundPage = lazy(() => import('@/pages/public/NotFoundPage').then((m) => ({ default: m.NotFoundPage })));
const LegalPage = lazy(() => import('@/pages/public/others/LegalPage').then((m) => ({ default: m.LegalPage })));
const PrivacyPage = lazy(() => import('@/pages/public/others/PrivacyPage').then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import('@/pages/public/others/TermsPage').then((m) => ({ default: m.TermsPage })));
const CookiePage = lazy(() => import('@/pages/public/others/CookiePage').then((m) => ({ default: m.CookiePage })));
const SupplierAgreementPage = lazy(() =>
  import('@/pages/public/others/SupplierAgreementPage').then((m) => ({ default: m.SupplierAgreementPage }))
);
const PartnerAgreementPage = lazy(() =>
  import('@/pages/public/others/PartnerAgreementPage').then((m) => ({ default: m.PartnerAgreementPage }))
);
const WithdrawalExemptionPage = lazy(() =>
  import('@/pages/public/others/WithdrawalExemptionPage').then((m) => ({ default: m.WithdrawalExemptionPage }))
);
const TravelerAgreementPage = lazy(() =>
  import('@/pages/public/others/TravelerAgreementPage').then((m) => ({ default: m.TravelerAgreementPage }))
);
const AboutPage = lazy(() => import('@/pages/public/others/AboutPage').then((m) => ({ default: m.AboutPage })));
const ContactPage = lazy(() => import('@/pages/public/others/ContactPage').then((m) => ({ default: m.ContactPage })));
const HelpCenterPage = lazy(() =>
  import('@/pages/public/others/HelpCenterPage').then((m) => ({ default: m.HelpCenterPage }))
);
const WorkWithUsPage = lazy(() =>
  import('@/pages/public/others/WorkWithUsPage').then((m) => ({ default: m.WorkWithUsPage }))
);
const ForPartnersPage = lazy(() =>
  import('@/pages/public/others/ForPartners').then((m) => ({ default: m.ForPartnersPage }))
);
const ForSuppliersPage = lazy(() =>
  import('@/pages/public/others/ForSuppliers').then((m) => ({ default: m.ForSuppliersPage }))
);
const StatusPage = lazy(() =>
  import('@/pages/public/others/StatusPage').then((m) => ({ default: m.StatusPage }))
);
const AttractionsPage = lazy(() =>
  import('@/pages/public/AttractionsPage').then((m) => ({ default: m.AttractionsPage }))
);
const BlogListPage = lazy(() => import('@/pages/public/BlogListPage').then((m) => ({ default: m.BlogListPage })));
const BlogPostPage = lazy(() =>
  import('@/pages/public/content/BlogPostPage').then((m) => ({ default: m.BlogPostPage }))
);

export const publicRoutes = (
  <>
    <Route element={<PublicLayout />}>
      <Route path="/" element={<HomePage />} />
      <Route path="/destinations" element={<DestinationsPage />} />
      <Route path="/search" element={<SearchToursPage />} />
      <Route path="/categories/:category" element={<SearchByCategoryPage />} />
      <Route path="/attractions" element={<AttractionsPage />} />
      <Route path="/blog" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/about-us" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/help-center" element={<HelpCenterPage />} />
      <Route path="/work-with-us" element={<WorkWithUsPage />} />
      <Route path="/status" element={<StatusPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/legal/privacy" element={<PrivacyPage />} />
      <Route path="/legal/cookies" element={<CookiePage />} />
      <Route path="/legal/terms" element={<TermsPage />} />
      <Route path="/legal/supplier-agreement" element={<SupplierAgreementPage />} />
      <Route path="/legal/partner-agreement" element={<PartnerAgreementPage />} />
      <Route path="/legal/withdrawal-exemption" element={<WithdrawalExemptionPage />} />
      <Route path="/legal/traveler-agreement" element={<TravelerAgreementPage />} />
      <Route path="/for-partners" element={<ForPartnersPage />} />
      <Route path="/for-suppliers" element={<ForSuppliersPage />} />
      <Route path="/supplier/:slug" element={<ProfilePage />} />

      {/* 7. DYNAMIC SEO ROUTES (Lowest Priority) */}
      <Route path="/:country" element={<SearchByCountryPage />} />
      <Route path="/:country/:city" element={<SearchByCityPage />} />
      <Route path="/:country/:city/attractions/:attraction" element={<SearchByAttractionPage />} />
      <Route path="/:country/category/:category" element={<SearchByCountryCategoryPage />} />
      <Route path="/:country/:city/category/:category" element={<SearchByCityCategoryPage />} />
      <Route path="/:country/:city/tour/:id" element={<ActivityPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>

    {/* 8. UTILITY ROUTES */}
    <Route path="/explore" element={<ExplorePage />} />
    <Route path="/pay" element={<CheckoutPage />} />
    <Route path="/booking-confirmed/:bookingCode" element={<SuccessPage />} />
    <Route path="/review" element={<ReviewPage />} />
    <Route path="/review/:bookingCode" element={<ReviewPage />} />
    <Route path="/widget/:id" element={<EmbeddedWidget />} />
    <Route path="/test-embed/:id" element={<TestEmbedPage />} />
  </>
);
